var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgJigsaw = function SvgJigsaw(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.083 10.167h-1.25V6.833c0-.916-.75-1.666-1.666-1.666h-3.334v-1.25a2.084 2.084 0 0 0-4.166 0v1.25H6.333c-.916 0-1.658.75-1.658 1.666V10h1.242a2.251 2.251 0 0 1 0 4.5h-1.25v3.167c0 .916.75 1.666 1.666 1.666H9.5v-1.25a2.25 2.25 0 0 1 2.25-2.25 2.25 2.25 0 0 1 2.25 2.25v1.25h3.167c.916 0 1.666-.75 1.666-1.666v-3.334h1.25a2.084 2.084 0 0 0 0-4.166"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJigsaw);
export { ForwardRef as ReactComponent };